import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLegacyPublicApiTokenCount } from '../../api/medtech-api';
import { PermissionWrapper } from '../../views/EditUser/EditUserForm/components/PermissionWrapper';
import { CacheKeys } from '../../types';
import { createErrorToast } from '../../utils/toast.utils';
import APICapabilitiesPermissions from '../FormComponents/APICapabilitiesPermissions';

export const LegacyPublicApiUserPermission: React.FC = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();
  const { data, isError } = useQuery([CacheKeys.LEGACY_API_KEYS, companyId], () =>
    getLegacyPublicApiTokenCount(companyId),
  );

  if (isError) {
    showToast(createErrorToast(t('apiCapabilities.errorFetchKeys'), 'api-capabilities-fetch-error-toast'));
    return <div />;
  }
  const showApiPermission = data?.count !== 0;
  const description = t('apiCapabilities.deprecatedDescription');

  return (
    <PermissionWrapper shouldRender={showApiPermission} header={t('apiCapabilities.header')} description={description}>
      <APICapabilitiesPermissions />
    </PermissionWrapper>
  );
};
